import { Handle, Position, type NodeProps } from '@xyflow/react';
import { DecisaoParticipacao } from '@nexital/shared';
import { useQuadro } from '../../application/dependencias';
import { Avatar } from '../design-system/Avatar';
import { MenuCartao } from './MenuCartao';
import type { NoCartaoTipo } from './montar-nos';
import { useSolturaNoCartao } from './use-soltura-arquivos';

const DECISAO: Record<DecisaoParticipacao, string | null> = {
  [DecisaoParticipacao.EmAvaliacao]: null,
  [DecisaoParticipacao.Participar]: 'Participar',
  [DecisaoParticipacao.NaoParticipar]: 'Não participar',
};

/** Cartão post-it do processo. Compacto entre 30% e 60% de zoom; oculto abaixo disso (RQ-QDR-006). */
export function NoCartao({ data, selected }: NodeProps<NoCartaoTipo>) {
  const nivel = useQuadro((s) => s.nivel);
  const { processo, cor } = data;
  const decisao = DECISAO[processo.decisaoParticipacao];
  const soltura = useSolturaNoCartao(processo);

  return (
    <article
      className={`cartao cartao--${nivel}${selected ? ' cartao--selecionado' : ''}${soltura.realce ? ' cartao--recebendo' : ''}`}
      style={{ '--cor': cor } as React.CSSProperties}
      aria-label={`${processo.numero} — ${processo.objeto}`}
      {...soltura.props}
    >
      {/* Pontas invisíveis: as setas (RQ-NOT-004) chegam e saem do cartão. */}
      <Handle type="target" position={Position.Left} className="ponta-oculta" isConnectable={false} />
      <Handle type="source" position={Position.Right} className="ponta-oculta" isConnectable={false} />
      {data.editandoPor && <span className="no-editando">{data.editandoPor} está editando</span>}
      <MenuCartao processo={processo} />
      <h3 className="cartao__numero">{processo.numero}</h3>
      <p className="cartao__objeto">{processo.objeto}</p>
      {nivel === 'completo' && <p className="cartao__orgao">{processo.orgao}</p>}
      {nivel === 'completo' && decisao && <span className="pilula pilula--informacao">{decisao}</span>}
      {processo.responsavel && (
        <footer className="cartao__rodape">
          <Avatar nome={processo.responsavel.nome} chave={processo.responsavel.uuid} tamanho={nivel === 'completo' ? 26 : 34} />
          {nivel === 'completo' && <span>{processo.responsavel.nome.split(' ')[0]}</span>}
        </footer>
      )}
    </article>
  );
}
